import React from 'react';
import styled from 'styled-components';
import round from 'lodash/round';
import noonConfig from '@com/core/noon/noonConfig';
import { useTranslation } from '@com/core/common/translations/i18n';
import CountdownTimer from '../countdownTimer/CountdownTimer';

type TProps = {
    expiry: string;
    stockGross: number;
    stockNet: number;
    size?: 'regular' | 'large';
};

const LimitedDealBar = ({ expiry, size = 'regular', stockGross, stockNet }: TProps): JSX.Element => {
    const { t } = useTranslation('common');

    const MIN_STOCK_SHOW = 10;
    const qtyBarPerc = round(100 - (stockNet / stockGross) * 100);

    const { flame, hourglass } = noonConfig.assets.icons;

    return (
        <Container className={size}>
            <div className="group">
                <img src={hourglass} alt="hourglass" />
                <CountdownTimer endTime={expiry} />
            </div>
            <div className="group">
                <img src={flame} alt="flame" />
                {stockNet < MIN_STOCK_SHOW ? (
                    <span>{t('_units-left', { units: stockNet })}</span>
                ) : (
                    <span>{t('_percent-claimed', { perc: qtyBarPerc })}</span>
                )}
            </div>
        </Container>
    );
};

const Container = styled.div`
    display: inline-flex; /* time > remaining */
    align-items: center;
    color: ${({ theme: { colors } }) => colors.marketBlue};
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 1px;
    padding: 2px 4px;
    font-size: 0.714rem;
    font-weight: 600;
    white-space: nowrap;

    &.large {
        font-size: 0.925rem;

        .group {
            img {
                width: 16px;
                height: 16px;
            }
        }
    }

    .group + .group {
        ${({ theme: { left } }): string => `margin-${left}: 6px`};
    }

    .group {
        display: flex;
        align-items: center;

        img {
            ${({ theme: { right } }): string => `margin-${right}: 2px`};
        }
    }
`;

export default LimitedDealBar;
